var scope_0 = require('/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/20728189adb742130288a043d03f2f5b.js').default;
var scope_1 = require('/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    